import { AllieIconProps } from '../../../components';

export const DotIcon: React.FC<AllieIconProps> = ({ color = 'var(--allie-color-primary-90)' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <circle cx="4" cy="4" r="3" fill={color} />
  </svg>
);
